import { WIX_FORMS, CUSTOM_LOGIN } from '@wix/app-definition-ids';
export const CMS_APP_ID = 'dataBinding';
export const WIX_CODE_APP_ID = 'wix-code';
export let MembersWidgetAppId = /*#__PURE__*/function (MembersWidgetAppId) {
  MembersWidgetAppId[MembersWidgetAppId["SignUp"] = WIX_FORMS] = "SignUp";
  MembersWidgetAppId[MembersWidgetAppId["SignIn"] = CUSTOM_LOGIN] = "SignIn";
  return MembersWidgetAppId;
}({});
export let MembersCustomPageManagedByWixAppId = /*#__PURE__*/function (MembersCustomPageManagedByWixAppId) {
  MembersCustomPageManagedByWixAppId["SignUp"] = "5f4fa4f1-5afd-4ac0-8a85-e5ac1d2b9b7d";
  MembersCustomPageManagedByWixAppId["SignIn"] = "bbe1406a-31f5-4f3f-9e0a-b39dfd25274f";
  return MembersCustomPageManagedByWixAppId;
}({});
export const DEFAULT_BRANCH_ID = '00000000-0000-0000-0000-000000000000';
//# sourceMappingURL=consts.js.map